import Table from "../components/Table";
import RecordFilter from "../components/Filters/RecordFilter";
import { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";

import AppLayout from "../layouts/AppLayout";
import NewRecordForm from "./NewRecordForm";
import { apiGet, apiPatch, deletePost } from "../inc/ApiHelpers";
import Pagination from "../components/Pagination";
import { useSearchParams } from "react-router-dom";
import { useGlobalContext } from "../contexts/GlobalContext";
import { getData } from "../inc/Helpers";

function Records() {
	const {
		setPaginationData,
		showNewFormModal,
		setShowNewFormModal,
		updatePageTitle,
		setToast,
		updateAnimationState,
		sortTableBy,
	} = useGlobalContext();

	const arraySort = require("array-sort");

	const pathName = "/records";

	const [data, setData] = useState();

	const [isLoading, setIsLoading] = useState(false);
	const [isSearch, setIsSearch] = useState(false);
	const [statuses, setStatuses] = useState();
	const [showVisibleColumnsDropdown, setShowVisibleColumnsDropdown] =
		useState(false);

	const [visibleTableColumns, setVisibleTableColumns] = useState({
		name: true,
		phone: true,
		address: true,
		problems: true,
		services: true,
		brand: true,
		model: true,
		imei: true,
		status: true,
		acceptance_date: true,
		repair_date: true,
		approximate_cost: true,
		final_charge: true,
		note: true,
		id: true,
		action: true,
	});

	const [searchParams] = useSearchParams();

	const curPageNo = searchParams.get("page")
		? parseInt(searchParams.get("page"))
		: 1;

	const emptyFormData = {
		name: "",
		phone: "",
		address: "",
		problems: "",
		services: "",
		brand: "",
		model: "",
		imei: "",
		status_id: "",
		acceptance_date: new Date().toISOString().substring(0, 10),
		repair_date: "",
		approximate_cost: "",
		final_charge: "",
		note: "",
		id: "",
	};

	const [defaultFormData, setDefaultFormData] = useState(emptyFormData);

	/**
	 * It resets the form data to default values and shows the modal.
	 */
	const showEmptyFormModal = () => {
		// reset form data when clicked on green "add new " btn.
		setDefaultFormData(emptyFormData);

		// show modal.
		setShowNewFormModal(true);
	};

	/**
	 * Send API request with the filter data.
	 *
	 * @param data - the data object that contains the filter values.
	 */
	const handleFilterSearch = async (data) => {
		let query = data.query;
		let fromDate = data.fromDate;
		let toDate = data.toDate;
		let status = data?.status.map((item) => item.value);

		getData(
			"/api/records?query=" +
				query +
				"&fromDate=" +
				fromDate +
				"&toDate=" +
				toDate +
				"&status=" +
				status +
				"&page=" +
				curPageNo,
			setIsLoading,
			apiGet,
			setData,
			setPaginationData,
			setToast
		);
	};

	/**
	 * When the edit button is clicked, we filter the data array to get the selected item, then we
	 * update the default form data with the selected item and show the modal
	 * @param id - The id of the item to be edited.
	 */
	const onEditClick = (id) => {
		let selData = data.filter((item) => item.id === id);
		selData[0].seloption = {
			value: selData[0]?.statuses?.id,
			label: selData[0]?.statuses?.title,
		};
		// update default form data.
		setDefaultFormData(...selData);

		// show modal.
		setShowNewFormModal(true);
	};

	/**
	 * `resetForm` resets the form fields to their default values
	 */
	const resetForm = () => {
		if (window.confirm("Are you sure?")) {
			setDefaultFormData(emptyFormData);
		}
	};

	/**
	 * It deletes a row from the database and updates the state
	 * @param id - the id of the row to delete.
	 */
	const deleteRow = async (id) => {
		try {
			deletePost("/api/records/" + id);

			updateAnimationState({
				id: id,
				action: "delete",
				callback: () => {
					// update state.
					setData((prev) => prev.filter((item) => item.id !== id));
				},
			});
		} catch (e) {
			setToast(e.response.data.message, "danger");
		}
	};

	/**
	 * Re-format data to suit our layout
	 * @param data - the data that is being passed in from the parent component
	 * @returns An array of objects.
	 */
	const reFormatData = (data) => {
		if (!data) return;

		let tempData = [];

		data.map((item) =>
			tempData.push({
				...item,
				status: item.statuses.title,
				status_color: item.statuses.color,
			})
		);

		return tempData;
	};

	/**
	 * When the user changes the value of a checkbox, update the state of the visibleTableColumns object
	 * with the new value.
	 * @param e - the event object
	 */
	const handleVisibleColumnOptionChange = (e) => {
		setVisibleTableColumns((prev) => ({
			...prev,
			[e.target.id]: e.target.checked,
		}));

		// update in api
		apiPatch({
			url: "/api/tablesettings/update-visible-columns/records",
			...{
				visibleColumns: {
					...visibleTableColumns,
					[e.target.id]: e.target.checked,
				},
			},
		});
	};

	useEffect(() => {
		/* A callback function that fetches data from the server and updates the state. */
		getData(
			"/api/records?page=" + curPageNo,
			setIsLoading,
			apiGet,
			setData,
			setPaginationData,
			setToast
		);

		/* It updates the page title. */
		updatePageTitle(pathName);

		// get all statuses
		try {
			apiGet("/api/status").then((res) => {
				setStatuses(res.data);
			});
		} catch (e) {
			setToast(e.response.data.message, "danger");
		}
	}, [curPageNo]);

	useEffect(() => {
		setData((prev) =>
			arraySort(prev, sortTableBy[0], {
				reverse: sortTableBy[1] === "asc",
			})
		);
	}, [sortTableBy]);

	useEffect(() => {
		apiGet("/api/tablesettings/get-visible-columns/records").then((res) => {
			// update visibleTableColumns state.
			setVisibleTableColumns((prev) => ({ ...prev, ...res.visibleColumns }));
		});
	}, []);

	return (
		<AppLayout>
			<div className='app-body px-3 md:px-8 pt-5 md:pt-6  print:p-0'>
				<PageHeader onClick={showEmptyFormModal} />

				{statuses && (
					<RecordFilter
						handleFilterSearch={handleFilterSearch}
						setIsSearch={setIsSearch}
						isSearch={isSearch}
						statuses={statuses}
					/>
				)}

				<Table
					theads={[
						{ id: "id", label: "ID", sortBy: "id" },
						{
							id: "acceptance_date",
							label: "Accepted",
							sortBy: "acceptance_date",
						},
						"name",
						"phone",
						"address",
						"brand",
						"model",
						"imei",
						"problems",
						{ id: "status", label: "Status", sortBy: "statuses.title" },
						{ id: "repair_date", label: "Repaired", sortBy: "repair_date" },
						"services",
						{
							id: "approximate_cost",
							label: "Appr. Cost",
							sortBy: "approximate_cost",
						},
						{ id: "final_charge", label: "Final Cost", sortBy: "final_charge" },
						"note",
						"action",
					]}
					setShowModal={showEmptyFormModal}
					data={reFormatData(data)}
					handleDelete={deleteRow}
					handleJobsheetPrint={(id) => {
						window.open("/print-jobsheet/" + id);
					}}
					onEditClick={onEditClick}
					isLoading={isLoading}
					isSearch={isSearch}
					showVisibleColumnsDropdown={showVisibleColumnsDropdown}
					setShowVisibleColumnsDropdown={setShowVisibleColumnsDropdown}
					handleVisibleColumnOptionChange={handleVisibleColumnOptionChange}
					visibleTableColumns={visibleTableColumns}
				/>

				<Pagination />
			</div>

			<NewRecordForm
				setData={setData}
				defaultFormData={defaultFormData}
				isVisible={showNewFormModal}
				resetForm={resetForm}
				emptyFormData={emptyFormData}
				statuses={statuses}
			/>
		</AppLayout>
	);
}

export default Records;
